(function () {
  function init() {
    document.querySelectorAll(".rm-wrap").forEach((wrap) => {
      const content = wrap.querySelector(".rm-content");
      const btn = wrap.querySelector(".rm-toggle");
      if (!content || !btn) return;

      const collapsed = parseInt(getComputedStyle(content).maxHeight, 10);
      if (content.scrollHeight <= collapsed + 5) {
        btn.style.display = "none";
        return;
      }

      btn.addEventListener("click", () => {
        const open = wrap.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.textContent = open ? (btn.dataset.less || "Read less") : (btn.dataset.more || "Read more");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

